const unixTimestampInSeconds = () => {
  return Math.floor(Date.now() / 1000).toString();
};

export default unixTimestampInSeconds;
